import { GjwClient, HttpClient, type ClientState, type WebSocketLike } from "@gjwtrack/client";
import { useSyncExternalStore } from "react";

const wsUrl = (): string => `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/ws`;

/** One client per tab. Pages open and close views on it; components read its store. */
export const client = new GjwClient({
  http: new HttpClient(),
  createSocket: () => new WebSocket(wsUrl()) as unknown as WebSocketLike,
  log: (m) => console.debug(`[gjw] ${m}`),
});

/** Subscribe a component to a slice of client state. Return stable references from `select`. */
export function useClient<T>(select: (s: ClientState) => T): T {
  return useSyncExternalStore(client.store.subscribe, () => select(client.store.get()));
}
